export default __webpack_public_path__ + "static/hero_partner_img_5-8532fe4d65f5d5202ba8407fcb5d0e9c.png";